const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'fqdn', label: 'FQDN', sortable: false, thStyle: 'width: 18%' },
    { key: 'created_at', label: 'Inspected time', sortable: true },
    { key: 'count', label: 'Total Pages (Page / External / Resource)', sortable: false },
    { key: 'status', label: 'Result', sortable: false },
    { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'fqdn', label: 'FQDN', sortable: false, thStyle: 'width: 18%' },
    { key: 'created_at', label: '점검 시간', sortable: true },
    { key: 'count', label: '총 페이지 (페이지 / 외부 / 리소스 )', sortable: false },
    { key: 'status', label: '결과', sortable: false },
    { key: 'func', label: '기능', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'fqdn', label: 'FQDN', sortable: false, thStyle: 'width: 18%' },
    { key: 'created_at', label: '検査時間', sortable: true },
    { key: 'count', label: 'トータルページ (ページ / 外部 / リソース)', sortable: false },
    { key: 'status', label: '結果', sortable: false },
    { key: 'func', label: 'アクション', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const _i18n_info = {
  update_check : {
    EN: `update checking info`,
    KO: `update checking info`,
    JP: `更新チェック情報`
  },
  scan_stop : {
    EN: `request to stop`,
    KO: `request to stop`,
    JP: `停止を要求`
  }
}

const _i18n_error = {
  result_select: {
    EN: `Data is not Available`,
    KO: `Data is not Available`,
    JP: `データが利用できません`
  },
  scan_stop: {
    EN: `stop request failed`,
    KO: `stop request failed`,
    JP: `停止要求が失敗しました`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_info,
  _i18n_error
}

export default _i18n_data